/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OrganizationsResendInvitation$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * The ID of the invitation to resend
 */
  invitationId: string;
}

export function organizationsResendInvitation(http: HttpClient, rootUrl: string, params: OrganizationsResendInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The status of the resent invitation
 */
'status'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsResendInvitation.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('invitationId', params.invitationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * The status of the resent invitation
       */
      'status'?: string;
      }>;
    })
  );
}

organizationsResendInvitation.PATH = '/organizations/{organizationId}/users/invitations/{invitationId}/resend';
